export default __webpack_public_path__ + "static/media/skrytyy_vagon.933ddeb0.svg";